import { render } from "./Modal.vue?vue&type=template&id=5ae87d1b&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=5ae87d1b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ae87d1b"

export default script